export const REPORTS_SETTING_KEY = 'reports-settings'
export const PERIOD_SET_ID_PARAM = 'report_period_set_id'
export const SELECTED_DIMENSIONS_PARAM = 'selected_dimensions'
export const RENDER_PARAM = 'render'

// MessageBus channel a deferred report render publishes its completion on.
// Must match Report::AsyncRenderCoordinator::CHANNEL on the backend.
export const ASYNC_RENDER_CHANNEL = '/reports/render'

// Pinned graph chart heights — used by the drawer's PinnedGraphCard and the
// reports-index PinnedReportCard. Fullscreen value is only relevant to the
// drawer (the index card is always compact).
export const PINNED_CHART_HEIGHT_DEFAULT = '260px'
export const PINNED_CHART_HEIGHT_FULLSCREEN = '520px'

// Resizable graphs-drawer width, stored per user as a percentage of the layout
// wrapper. Bounds must match UserPreferencesContract::REPORT_GRAPHS_DRAWER_WIDTH_RANGE.
export const REPORT_GRAPHS_DRAWER_MIN_WIDTH_PCT = 15
export const REPORT_GRAPHS_DRAWER_MAX_WIDTH_PCT = 60
